import * as React from 'react';

export const DepartureIcon = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.23 8.58C21.03 8.36 21.86 8.84 22.07 9.64C22.28 10.44 21.81 11.26 21 11.49L4.43 15.92L3.66 14.59L1.84 11.43L3.29 11.04L5.26 12.58L10.23 11.25L6.09 4.08L8.02 3.57L14.92 10L20.23 8.58ZM21.5 19H2.5V21H21.5V19Z"
			fill="currentColor"
		/>
	</svg>
);

export const ArrivalIcon = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M21.18 14.79C20.96 15.59 20.14 16.06 19.34 15.85L2.77 11.41V6.24L4.22 6.63L5.15 8.95L10.12 10.28V2L12.05 2.51L14.81 11.53L20.12 12.95C20.92 13.17 21.39 13.99 21.18 14.79ZM21.5 19H2.5V21H21.5V19Z"
			fill="currentColor"
		/>
	</svg>
);

export const DetailsIcon = (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.6665 9.99996C1.6665 5.39996 5.39984 1.66663 9.99984 1.66663C14.5998 1.66663 18.3332 5.39996 18.3332 9.99996C18.3332 14.6 14.5998 18.3333 9.99984 18.3333C5.39984 18.3333 1.6665 14.6 1.6665 9.99996ZM10.8332 9.16663V14.1666H9.1665V9.16663H10.8332ZM9.99983 16.6666C6.32483 16.6666 3.33316 13.675 3.33316 9.99996C3.33316 6.32496 6.32483 3.33329 9.99983 3.33329C13.6748 3.33329 16.6665 6.32496 16.6665 9.99996C16.6665 13.675 13.6748 16.6666 9.99983 16.6666ZM10.8332 5.83329V7.49996H9.1665V5.83329H10.8332Z"
			fill="currentColor"
		/>
	</svg>
);
